import { render } from "./issueList.vue?vue&type=template&id=0687a2b3&scoped=true"
import script from "./issueList.vue?vue&type=script&lang=js"
export * from "./issueList.vue?vue&type=script&lang=js"

import "./issueList.vue?vue&type=style&index=0&id=0687a2b3&scoped=true&lang=css"

import exportComponent from "E:\\项目\\潞安6s移动端\\H5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0687a2b3"]])

export default __exports__